<ng-container *ngIf="tipRacuna === TipRacuna.AVANSNI_RACUN; else racuniSaldo">
  <ng-container *ngTemplateOutlet="avansniRacuniSaldo"></ng-container>
</ng-container>

<ng-template #racuniSaldo>
  <div
    class="p-d-flex p-flex-column gap-8"
    *ngIf="!isLoading; else racuniSaldoSkeleton"
  >
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card
        class="flex-1"
        topText="Promet (sa PDV)"
        [mainText]="saldoFakture.finansijskiPromet | currencyNumber"
        [bottomText]="
          (saldoFakture.finansijskiPromet -
            saldoFakture.pdv10 -
            saldoFakture.pdv20 | currencyNumber) + ' bez PDV'
        "
      >
      </kodit-saldo-card>
      <kodit-saldo-card
        class="flex-1"
        [topText]="(saldoPlacenoData | saldoPlaceno).toString()
        "
        [mainText]="
          (saldoPlacenoData | saldoPlaceno:'number') | currencyNumber
        "
        mainTextClass="text-green"
      >
        <!-- [bottomText]="saldo.fakturaPlacenoPercent + '% prometa'"-->
        <ng-container additional-content>
          <div class="progressbar-wrapper">
            <p-progressBar
              [value]="saldoFakture.placenoPercent"
              [showValue]="false"
            ></p-progressBar>
            <!-- <div class="p-d-flex p-jc-center gap-12 p-mt-2">
              <div class="p-d-flex p-ai-center gap-6">
                <div class="dot green"></div>
                <div>plaćeno</div>
              </div>
              <div class="p-d-flex p-ai-center gap-6">
                <div class="dot grey"></div>
                <div>otvoreno</div>
              </div>
            </div> -->
          </div>
        </ng-container>
      </kodit-saldo-card>

    </div>
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card
        class="flex-1"
        [topText]="
          'Otvorene fakture (' + (saldoFakture.neplacenoCnt | number) + ')'
        "
        [mainText]="saldoFakture.neplacenoIznos | currencyNumber"
        mainTextClass="text-red"
      >
      </kodit-saldo-card>
      <kodit-saldo-card
          class="flex-1"
          [topText]="
            'Fakture u kašnjenju (' + (saldoFakture.vanValuteCnt | number) + ')'
          "
          [mainText]="saldoFakture.vanValuteIznos | currencyNumber"
          [displayActionBtn]="displayPodsetnikZaPlacanjeBtn"
          mainTextClass="text-red"
        >
          <ng-container action-button>
            <kodit-button
              btnTooltip="Pošalji podsetnik za neizmirene obaveze na imejl"
              btnIcon="far fa-paper-plane"
              (btnClicked)="handlePodsetnikZaPlacanje()"
            >
            </kodit-button>
          </ng-container>
        </kodit-saldo-card>
    </div>
<!--    <div class="p-d-flex flex-1 gap-8">-->
<!--      <kodit-saldo-card-->
<!--        class="flex-1"-->
<!--        [topText]="-->
<!--          'Fakture u kašnjenju (' + (saldoFakture.vanValuteCnt | number) + ')'-->
<!--        "-->
<!--        [mainText]="saldoFakture.vanValuteIznos | currencyNumber"-->
<!--        [displayActionBtn]="displayPodsetnikZaPlacanjeBtn"-->
<!--        mainTextClass="text-red"-->
<!--      >-->
<!--        <ng-container action-button>-->
<!--          <kodit-button-->
<!--            btnTooltip="Pošalji podsetnik za neizmirene obaveze na imejl"-->
<!--            btnIcon="far fa-paper-plane"-->
<!--            (btnClicked)="handlePodsetnikZaPlacanje()"-->
<!--          >-->
<!--          </kodit-button>-->
<!--        </ng-container>-->
<!--      </kodit-saldo-card>-->
<!--      <kodit-saldo-card-->
<!--        class="flex-1"-->
<!--        [topText]="-->
<!--          'Dospeva u narednih 30 dana (' +-->
<!--          (saldoFakture.dospevaZa30DanaCnt | number) +-->
<!--          ')'-->
<!--        "-->
<!--        [mainText]="saldoFakture.dospevaZa30Dana | currencyNumber"-->
<!--        mainTextClass="text-blue"-->
<!--      >-->
<!--      </kodit-saldo-card>-->
<!--      <kodit-saldo-card-->
<!--        class="flex-1"-->
<!--        topText="Prosečno vreme naplate (U poslednjih 90 dana)"-->
<!--        [mainText]="-->
<!--          (saldoFakture.dso90Dana | number) +-->
<!--          ' ' +-->
<!--          (saldoFakture.dso90Dana % 10 === 1 && saldoFakture.dso90Dana !== 11-->
<!--            ? 'dan'-->
<!--            : 'dana')-->
<!--        "-->
<!--      >-->
<!--      </kodit-saldo-card>-->
<!--    </div>-->
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card
        class="flex-1"
        topText="Ukupno PDV 10%"
        topText2="Ukupno PDV 20%"
        topText3="Ukupno PDV (10% + 20%)"
        [mainText]="saldoFakture.pdv10 | currencyNumber"
        [mainText2]="saldoFakture.pdv20 | currencyNumber"
        [mainText3]="saldoFakture.pdv10 + saldoFakture.pdv20 | currencyNumber"
      >
      </kodit-saldo-card>
    </div>
  </div>
</ng-template>

<ng-template #avansniRacuniSaldo>
  <div
    class="p-d-flex p-flex-column gap-8"
    *ngIf="!isLoading; else avansniRacuniSkeleton"
  >
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card
        class="flex-1"
        topText="Ukupan iznos avansnih faktura (sa PDV)"
        [mainText]="saldoAvansa.ukupanIznos | currencyNumber"
        mainTextClass="text-blue"
        [bottomText]="(saldoAvansa.osnovica | currencyNumber) + ' bez PDV'"
      >
      </kodit-saldo-card>
      <kodit-saldo-card
        class="flex-1"
        topText="Iskorišćen avansi"
        [mainText]="
          saldoAvansa.evidentiranaOsnovica +
            saldoAvansa.evidantiranPdv10 +
            saldoAvansa.evidantiranPdv20 | currencyNumber
        "
        mainTextClass="text-green"
      >
      </kodit-saldo-card>
      <kodit-saldo-card
        class="flex-1"
        topText="Preostali avansi"
        [mainText]="
          saldoAvansa.preostalaOsnovica +
            saldoAvansa.preostaoPdv10 +
            saldoAvansa.preostaoPdv20 | currencyNumber
        "
        bottomText="Izdato, a nije iskorišćeno"
      >
      </kodit-saldo-card>
    </div>
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card
        class="flex-1"
        topText="Ukupno PDV 10%"
        topText2="Ukupno PDV 20%"
        topText3="Ukupno PDV (10% + 20%)"
        [mainText]="saldoAvansa.pdv10 | currencyNumber"
        [mainText2]="saldoAvansa.pdv20 | currencyNumber"
        [mainText3]="saldoAvansa.pdv10 + saldoAvansa.pdv20 | currencyNumber"
      >
      </kodit-saldo-card>
    </div>
  </div>
</ng-template>

<ng-template #racuniSaldoSkeleton>
  <div class="p-d-flex p-flex-column gap-8">
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="true"
        [showProgresPercent]="true"
      >
      </kodit-saldo-card-skeleton>
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="true"
      >
      </kodit-saldo-card-skeleton>
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="true"
      >
      </kodit-saldo-card-skeleton>
    </div>
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="false"
      >
      </kodit-saldo-card-skeleton>
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="false"
      >
      </kodit-saldo-card-skeleton>
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="false"
      >
      </kodit-saldo-card-skeleton>
    </div>
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showTopText2]="true"
        [showTopText3]="true"
        [showMainText]="true"
        [showMainText2]="true"
        [showMainText3]="true"
        [showBottomText3]="false"
      >
      </kodit-saldo-card-skeleton>
    </div>
  </div>
</ng-template>

<ng-template #avansniRacuniSkeleton>
  <div class="p-d-flex p-flex-column gap-8">
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="true"
      >
      </kodit-saldo-card-skeleton>
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="true"
      >
      </kodit-saldo-card-skeleton>
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showMainText]="true"
        [showBottomText]="true"
      >
      </kodit-saldo-card-skeleton>
    </div>
    <div class="p-d-flex flex-1 gap-8">
      <kodit-saldo-card-skeleton
        class="flex-1"
        [showTopText]="true"
        [showTopText2]="true"
        [showTopText3]="true"
        [showMainText]="true"
        [showMainText2]="true"
        [showMainText3]="true"
        [showBottomText3]="true"
      >
      </kodit-saldo-card-skeleton>
    </div>
  </div>
</ng-template>
